// extracted by mini-css-extract-plugin
export default {"image":"w3-z","loaded":"x3-z"};